module.exports = __webpack_public_path__ + "static/img/njbc.5dce2cb9.png";